<script>
import { roundCloseButton, leftButton, rightButton } from '@project/theme-buttons.vue'

export const gallery2Theme = {
  closeButton: roundCloseButton,
  rightButton,
  leftButton,
  highlightClasses:'fbicc-header-gallery2-thumbnail-highlight',
  suspendScrolling: true,
  featuredImageTheme: { "width": "100%", "fit":"cover", "lazy": true, "fill": false, "xsize": 1024   }    
}

export default { "name":"theme-gallery2" }
</script>

<style>
.fbicc-header-gallery2-thumbnail-highlight::after {
  content:"";
  position:absolute;
  top:0px; bottom:0px; left:0px; right:0px;
  background:black;
  opacity:0.4;
}
</style>